module.exports = __webpack_public_path__ + "img/homeTuisong.d1b8a341.svg";